// extracted by mini-css-extract-plugin
export default {"box":"checkbox_box__Ay7Nx","checkbox":"checkbox_checkbox__YdePu"};